import { render, staticRenderFns } from "./global-navigation-bar.vue?vue&type=template&id=72a1228e&"
import script from "./global-navigation-bar.vue?vue&type=script&lang=js&"
export * from "./global-navigation-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports